export const isComponentApplyStepStyling = () =>
  !(
    window.location.href.includes('recommended-investments') ||
    window.location.href.includes('confirm-investments')
  );
